export default {"src":"https://filecdn-other.xingyeai.com/xingye-ugc/_next/static/media/redo.a817a40c.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};